import { createI18n } from 'vue-i18n'
import en from '../lang/en'
import nl from '../lang/nl'

export default defineNuxtPlugin(async ({ vueApp }) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    silentTranslationWarn: true,
    locale: 'en',
    messages: {
      en: await en(),
      nl: await nl(),
    },
  })

  const localeDateFormat = () => {
    // Get the browser's language preference
    const browserLocale = navigator.language || navigator.userLanguage

    // Use Intl.DateTimeFormat to get the locale-specific date format
    const formatter = new Intl.DateTimeFormat(browserLocale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })

    // Initialize the date format string
    let dateFormat = ''

    // Iterate over the format parts and construct the date format string
    for (const part of formatter.formatToParts()) {
      switch (part.type) {
        case 'year':
          dateFormat += (dateFormat.length ? '/' : '') + 'yyyy'
          break
        case 'month':
          dateFormat += (dateFormat.length ? '/' : '') + 'MM'
          break
        case 'day':
          dateFormat += (dateFormat.length ? '/' : '') + 'dd'
          break
        default:
          break
      }
    }
    return dateFormat
  }

  vueApp.use(i18n)

  return {
    provide: {
      localeDateFormat: localeDateFormat(),
    },
  }
})
